import { UserAttribute } from '@prophecy/graphql-types/enums';

export function isDeploymentUXEnabled(user: { attributes: string[] }) {
  return user.attributes.includes(UserAttribute.DeploymentAttr);
}
